import React, { useEffect, useState } from "react";
import { Alert, Input, Button } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";

const GreenCardFlow = ({
    preview,
    email,
    rawText,
    onSubmit,
    onRetake
}) => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const [fields, setFields] = useState({
        uscisNumber: "",
        gcExpiration: ""
    });

    const updateField = (k, v) =>
        setFields(prev => ({ ...prev, [k]: v }));

    // -------------------------------------
    // OCR PARSER FOR GREEN CARD
    // -------------------------------------
    const parseGreenCard = (raw) => {
        const lines = raw.split("\n").map(l => l.trim()).filter(Boolean);
        let uscis = "";
        let exp = "";

        for (const line of lines) {
            const hyphens = (line.match(/-/g) || []).length;
            if (hyphens === 2) uscis = line; // Most common USCIS formatting
        }

        if (!uscis) {
            const m = raw.match(/(A[\d\-]{5,})/i);
            if (m) uscis = m[1].toUpperCase();
        }

        let idx = lines.findIndex(l => l.toLowerCase().includes("expire"));
        if (idx !== -1) {
            const candidates = [
                lines[idx],
                lines[idx + 1],
                lines[idx + 2]
            ].filter(Boolean);

            const formats = [
                /\b(\d{1,2}\/\d{1,2}\/\d{2,4})\b/,
                /\b(\d{1,2} [A-Za-z]{3} \d{4})\b/
            ];

            for (const c of candidates) {
                for (const r of formats) {
                    const m = c.match(r);
                    if (m) exp = m[1];
                }
            }
        }

        setFields({
            uscisNumber: uscis,
            gcExpiration: exp
        });
    };

    // -------------------------------------
    // FINAL SUBMIT
    // -------------------------------------
    const submitFinal = async () => {
        setError("");
        setLoading(true);

        if (!fields.uscisNumber) {
            setError("USCIS Number required");
            setLoading(false);
            return;
        }

        const payload = {
            type: "green_card",
            data: {
                email,
                uscis_number: fields.uscisNumber,
                expiration_date: fields.gcExpiration
            }
        };

        try {
            const resp = await onSubmit(payload);
            if (!resp || resp.code !== 1) {
                setError(resp?.message || "Save failed");
                setLoading(false);
                return;
            }
        } catch (err) {
            setError("Unexpected error");
            setLoading(false);
        }
    };

    useEffect(() => {
        if (rawText) parseGreenCard(rawText);
    }, [rawText]);

    // -------------------------------------
    // UI
    // -------------------------------------
    return (
        <>
            {error && <Alert color="danger">{error}</Alert>}

            <h1 className="text-dark mb-3 fw-semibold">Verify Green Card</h1>

            {preview && (
                <img
                    src={preview}
                    alt="green-card"
                    style={{
                        width: "100%",
                        borderRadius: 8,
                        marginBottom: 20
                    }}
                />
            )}

            <label>USCIS Number</label>
            <Input
                className="mb-3"
                value={fields.uscisNumber}
                onChange={(e) => updateField("uscisNumber", e.target.value.toUpperCase())}
            />

            <label>Expiration Date</label>
            <Input
                className="mb-3"
                value={fields.gcExpiration}
                onChange={(e) => updateField("gcExpiration", e.target.value)}
                placeholder="MM/DD/YYYY"
            />

            <StepCompleteActionButton
                label={loading ? "SAVING..." : "SUBMIT"}
                onClick={submitFinal}
                disabled={loading}
            />

            <Button className="w-100 mt-2" color="secondary" onClick={onRetake}>
                RETAKE PICTURE
            </Button>
        </>
    );
};

export default GreenCardFlow;